import { StatusBadge } from "@/components/status-badge";

type ComparisonStatus = "extracting" | "processing" | "completed" | "failed" | undefined;

const comparisonStatusConfig = {
  extracting: { label: "extracting", variant: "outline" },
  processing: { label: "processing", variant: "secondary" },
  completed: { label: "completed", variant: "default" },
  failed: { label: "failed", variant: "destructive" },
  undefined: { label: "unknown", variant: "outline" },
} as const;

export function ComparisonStatusBadge({
  status,
  className,
}: {
  status: ComparisonStatus;
  className?: string;
}) {
  const config = comparisonStatusConfig[String(status) as keyof typeof comparisonStatusConfig];
  return (
    <StatusBadge
      label={config.label}
      variant={config.variant}
      className={className}
    />
  );
}
